import { render, staticRenderFns } from "./tiscaliContactMe.vue?vue&type=template&id=7727fa52&"
import script from "./tiscaliContactMe.vue?vue&type=script&lang=js&"
export * from "./tiscaliContactMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports